import React from 'react';
import {Type} from "bukku/redux/Transaction/helper";
import {t} from '@lingui/macro';
import {
    CheckCircleOutlined, DeleteOutlined, EditOutlined,
    FileSearchOutlined, MinusCircleOutlined, PlusCircleOutlined,
    InboxOutlined, BankOutlined, FileTextOutlined,
    ShoppingCartOutlined,
    ControlOutlined,
    PercentageOutlined,
    BookOutlined,
    DiffTwoTone, PlusCircleTwoTone, MinusCircleTwoTone, FileProtectOutlined,
} from "@ant-design/icons";

export const AuditAction = {
    CREATED_DRAFT: 'CREATED_DRAFT',
    CREATED_READY: 'CREATED_READY',
    UPDATED: 'UPDATED',
    MARKED_READY: 'MARKED_READY',
    CREATED_PENDING_APPROVAL: 'CREATED_PENDING_APPROVAL',
    MARKED_PENDING_APPROVAL: 'MARKED_PENDING_APPROVAL',
    MARKED_VOID: 'MARKED_VOID',
    UNVOID: 'UNVOID',
    DELETED: 'DELETED',
    // For Contact, Product:
    CREATED: 'CREATED',
    DEACTIVATED: 'DEACTIVATED',
    ACTIVATED: 'ACTIVATED',
};

export const AuditActionLiteral = () => ({
    CREATED_DRAFT: t`Created as Draft`,
    CREATED_READY: t`Created as Ready`,
    UPDATED: t`Updated`,
    CREATED_PENDING_APPROVAL: t`Created as Pending Approval`,
    MARKED_PENDING_APPROVAL: t`Marked as Pending Approval`,
    MARKED_READY: t`Marked as Ready`,
    MARKED_VOID: t`Marked as Void`,
    UNVOID: t`Unvoid`,
    DELETED: t`Deleted`,
    // For Contact, Product:
    CREATED: t`Created`,
    DEACTIVATED: t`Deactivated`,
    ACTIVATED: t`Activated`,

});

export const AuditActionTagStyle = {
    CREATED_DRAFT: {color: 'green', icon: <PlusCircleOutlined />},
    CREATED_READY: {color: 'green', icon: <CheckCircleOutlined />},
    UPDATED: {color: 'blue', icon: <EditOutlined />},
    CREATED_PENDING_APPROVAL: {color: 'purple', icon: <FileSearchOutlined />},
    MARKED_PENDING_APPROVAL: {color: 'purple', icon: <FileSearchOutlined />},
    MARKED_READY: {color: 'orange', icon: <CheckCircleOutlined />},
    MARKED_VOID: {color: 'red', icon: <MinusCircleOutlined />},
    UNVOID: {color: 'orange', icon: <PlusCircleOutlined />},
    DELETED: {color: 'red', icon: <DeleteOutlined />},
    // For Contact, Product:
    CREATED: {color: 'green', icon: <PlusCircleOutlined />},
    DEACTIVATED: {color: 'red', icon: <MinusCircleOutlined />},
    ACTIVATED: {color: 'orange', icon: <PlusCircleOutlined />},

};

export const TransactionTypeLiteral = () => ({

    // Sales
    [Type.sale_invoice]: t`Invoice`,
    [Type.sale_credit_note]: t`Credit Note`,
    [Type.sale_delivery_order]: t`Delivery Order`,
    [Type.sale_payment]: t`Payment`,
    [Type.sale_refund]: t`Refund`,
    [Type.sale_quote]: t`Quotation`,
    [Type.sale_order]: t`Sales Order`,

    // Purchases
    [Type.purchase_order]: t`Purchase Order`,
    [Type.purchase_goods_received_note]: t`Goods Received Note`,
    [Type.purchase_bill]: t`Bill`,
    [Type.purchase_credit_note]: t`Purchase Credit Note`,
    [Type.purchase_payment]: t`Purchase Payment`,
    [Type.purchase_refund]: t`Purchase Refund`,

    // Bank
    [Type.bank_income]: t`Money In`,
    [Type.bank_expense]: t`Money Out`,
    [Type.bank_transfer]: t`Bank Transfer`,

    // Products
    [Type.stock_adjustment]: t`Stock Adjustment`,
    [Type.stock_transfer]: t`Stock Transfer`,

    // Accounting
    [Type.tax_deemed_payment]: t`Deemed Payment`,
    [Type.contra]: t`Contra`,
    [Type.journal_entry]: t`Journal Entry`,
    [Type.tax_deemed_payment]: t`Deemed Payment`,
});

export const FormItemName = {
    number_search: 'number_search',
    dates: 'dates',
    user: 'user',
    type: 'type',
};

export const InputRowHeight = {
    1: '32px',
    2: '54px',
    3: '74px',
    4: '98px',
};

export const DiffResultKey = {
    added: 'added',
    removed: 'removed',
    updated: 'updated',
    same: 'same',
};

export const AuditChannel = {
    TRANSACTION: 'TRANSACTION',
    SHOEBOX: 'SHOEBOX',
    BANK_RECONCILIATION: 'BANK_RECONCILIATION',
    FLOW: 'FLOW',
    STORE: 'STORE',
    INSTRUCTION: 'INSTRUCTION',
    INTEREST: 'INTEREST',
    PAYROLL: 'PAYROLL',
    MYINVOIS: 'MYINVOIS',
};
export const AuditChannelLiteral = {
    TRANSACTION: t`Transaction`,
    SHOEBOX: t`Shoebox`,
    BANK_RECONCILIATION: t`Bank Reconciliation`,
    FLOW: t`Flow`,
    STORE: t`Store`,
    INSTRUCTION: t`Instruction`,
    INTEREST: t`Interest Invoice`,
    PAYROLL: t`Payroll`,
    MYINVOIS: t`MyInvois`,
};
export const AuditChannelTagProps = {
    TRANSACTION: {color: 'blue', icon: <FileTextOutlined />},
    SHOEBOX: {color: 'blue', icon: <InboxOutlined />},
    BANK_RECONCILIATION: {color: 'blue', icon: <BankOutlined />},
    FLOW: {color: 'purple', icon: <ControlOutlined />},
    STORE: {color: 'purple', icon: <ShoppingCartOutlined />},
    INSTRUCTION: {color: 'orange', icon: <ControlOutlined />},
    INTEREST: {color: 'blue', icon: <PercentageOutlined />},
    PAYROLL: {color: 'blue', icon: <BookOutlined />},
    MYINVOIS: {color: 'blue', icon: <FileProtectOutlined />},
};

export const AuditSource = {
    APP: 'APP',
    API: 'API',
};
// eg for Product audit trail, tab General, UOM etc.
export const AuditTabsActionTagStyle = {
    [DiffResultKey.added]: {color: 'green', icon: <PlusCircleTwoTone twoToneColor="#52c41a" />, title: t`Added`},
    [DiffResultKey.removed]: {color: 'red', icon: <MinusCircleTwoTone twoToneColor="#f5222d" />, title: t`Removed`},
    [DiffResultKey.updated]: {color: 'gold', icon: <DiffTwoTone twoToneColor="#faad14" />, title: t`Updated`},
};
